import DialogModal from '@/components/DialogModal';
import { useTranslation } from 'react-i18next';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

function DeleteBlockModal({ isOpen, onClose, onSubmit }: Props) {
  const { t } = useTranslation('DeleteBlockModal');
  return (
    <DialogModal
      isOpen={isOpen}
      title={t('title.deleteBlock')}
      message={t('messages.confirmDelete')}
      onCancel={onClose}
      onConfirm={onSubmit}
      confirmVariant="danger"
      confirmText={t('buttons.deleteBlock')}
    />
  );
}

export default DeleteBlockModal;
